import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid2";
import DialogSearchMarketingCampaign from "../../../Dialog/Search/DialogSearchMarketingCampaign";
import TileMarketingCampaign from "../../../Tile/TileMarketingCampaign";
import PropTypes from "prop-types";
import MarketingCampaign from "../../../../Utility/Crud/MarketingCampaign";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterOrderActivityMarketingCampaign extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.marketingCampaignDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (marketingCampaign) => {
      const filter = this.props.queue.filter;
      if (!filter["order_activity.marketing_campaign_id"]?.properties?.value) {
        return;
      }
      filter["order_activity.marketing_campaign_id"].properties.value = filter[
        "order_activity.marketing_campaign_id"
      ].properties.value.filter((entry) => entry !== marketingCampaign);
      if (
        filter["order_activity.marketing_campaign_id"].properties.value
          .length === 0
      ) {
        delete filter["order_activity.marketing_campaign_id"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.["order_activity.marketing_campaign_id"]
        ?.properties?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.["order_activity.marketing_campaign_id"]
        ?.properties?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter["order_activity.marketing_campaign_id"].properties.operator = event
        .target.checked
        ? "not in"
        : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((marketingCampaignId) => {
              const marketingCampaign = MarketingCampaign.read(
                this.context.marketingCampaignsIndexed,
                [
                  {
                    key: "id",
                    value: marketingCampaignId,
                  },
                ],
              )[0];
              return (
                <MUIGrid
                  key={marketingCampaignId}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}
                >
                  <TileMarketingCampaign
                    marketingCampaign={marketingCampaign}
                    iconButtons={[
                      <MUIIconButton
                        onClick={() => handleRemove(marketingCampaignId)}
                      >
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState
            line1="Not Configured"
            line2="Showing all Marketing Campaigns"
          />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Order Status
   */
  renderDialog() {
    const handleAdd = (marketingCampaign) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["order_activity.marketing_campaign_id"]) {
        filter["order_activity.marketing_campaign_id"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter["order_activity.marketing_campaign_id"].properties.value = [
        ...new Set([
          ...(filter["order_activity.marketing_campaign_id"].properties.value ||
            []),
          marketingCampaign.id,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchMarketingCampaign
        open={this.state.marketingCampaignDialogOpen}
        onClose={() => this.setState({ marketingCampaignDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Order Statu button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        marketingCampaignDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Marketing Campaign
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Order Activity > Marketing Campaign";
  }
}
